import { Button, styled, SxProps, Theme, Typography } from '@mui/material';
import { memo, MouseEventHandler } from 'react';

interface IResetButtonprops {
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
  title?: string;
  sx?: SxProps<Theme>;
}

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100px',
  height: '40px',
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.mind.grey.A0,
  border: `1px solid ${theme.palette.mind.grey.disabled}`,
  borderRadius: '4px',

  '&:hover': {
    backgroundColor: theme.palette.mind.grey.greyHover,
  },
}));

function ResetButton(props: IResetButtonprops) {
  const { onClick, title = '초기화', sx = {} } = props;
  return (
    <StyledButton onClick={onClick} sx={sx}>
      <Typography>{title}</Typography>
    </StyledButton>
  );
}

export default memo(ResetButton);
